import script from "./editEnergy.vue?vue&type=script&setup=true&lang=js"
export * from "./editEnergy.vue?vue&type=script&setup=true&lang=js"

import "./editEnergy.vue?vue&type=style&index=0&id=6bf3a4cc&lang=less"

const __exports__ = script;

export default __exports__